import React, {useEffect, useState} from 'react';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {Card, CardBody, Col, Form, Row} from 'reactstrap';
import {FormProvider, useForm} from 'react-hook-form';
import UserForm from '../../../administrator/users/components/UserForm';
import {useNavigate, useParams} from 'react-router-dom';
import {IUserData} from '../../../../shared/interfaces/User';
import {yupResolver} from '@hookform/resolvers/yup/dist/yup';
import {usersManagementApi} from '../../../../api';
import {ICompany} from '../../../administrator/company/interfaces/ICompany';
import {userUpdateSchema} from '../../../administrator/users/components/UserUpdate';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../store';

const UserUpdate = () => {
  const {t} = useTranslation();
  const {roles} = useSelector((state: RootState) => state.auth.user);
  const navigate = useNavigate();
  const [passState, setPassState] = useState(false);
  const {id} = useParams();
  const methods = useForm<IUserData>({
    resolver: yupResolver(userUpdateSchema),
  });
  const isCompanyAdmin = roles?.some((role) => role === 'ROLE_COMPANY_ADMIN');
  const onFormSubmit = async (currentState: IUserData) => {
    const formData = new FormData();
    !!currentState.file && formData.append('picture', currentState.file[0]);
    formData.append('body', JSON.stringify(currentState));

    const {data} = await usersManagementApi.updateUser(Number(id), formData);
    if (data) {
      navigate('/app/management/users');
    }
  };

  useEffect(() => {
    if (id) {
      const getUser = async (userId: number) => {
        const {data} = await usersManagementApi.getUser(+userId);

        methods.reset({
          ...data,
          company: (data.company as unknown as ICompany)?.id,
        });
      };
      getUser(+id);
    }
  }, [methods, id]);
  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('management.users.updateUser')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate('/app/management/users');
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onFormSubmit)} className="py-3">
              <UserForm
                passState={passState}
                formState={methods.formState}
                setPassState={setPassState}
                register={methods.register}
                errors={methods.formState?.errors}
                isPasswordHidden
                isAdmin={false}
                isCompanyAdmin={isCompanyAdmin}
              />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.update')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default UserUpdate;
